import { connect } from 'react-redux';

import { IJsonQuery } from '../../../../../../../json_query';
import { EFacility } from '../../../../../../../json_query/types';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changeFacility } from '../../../../../../state/advanced/facilities';

import { BathType as BathTypeComponent, IBathTypeProps, EBathType } from './bathType';

type TBathTypeStateProps = Pick<IBathTypeProps, 'bathTypes'>;
type TBathTypeDispatchProps = Pick<IBathTypeProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TBathTypeStateProps {
  return {
    bathTypes: getBathTypes(state.filters.jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TBathTypeDispatchProps {
  return {
    onChange: (value: EBathType[]) => {
      if (value.includes(EBathType.Bath)) {
        dispatch(changeFacility(EFacility.Bath, true));
      } else {
        dispatch(changeFacility(EFacility.Bath, false));
      }

      if (value.includes(EBathType.Shower)) {
        dispatch(changeFacility(EFacility.Shower, true));
      } else {
        dispatch(changeFacility(EFacility.Shower, false));
      }
    },
  };
}

export const BathType = connect(mapStateToProps, mapDispatchToProps)(BathTypeComponent);

export function getBathTypes(jsonQuery: IJsonQuery): EBathType[] {
  const bathTypes: EBathType[] = [];

  if (jsonQuery.bath && jsonQuery.bath.value) {
    bathTypes.push(EBathType.Bath);
  }

  if (jsonQuery.shower && jsonQuery.shower.value) {
    bathTypes.push(EBathType.Shower);
  }

  return bathTypes;
}
